export default __webpack_public_path__ + "static/media/customer-service-man.f19fa8a0.svg";